import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { _Api } from '../api/_call';
import TableColumnModal from '../common/modules/tableColumn';
import ConfirmationModel from '../common/modules/confirmationmodel';
import { inventorySummarytableHead } from '../common/Tablehead';
import SocialModal from '../common/modules/SocialModal/SocialModal';
import ProductModal from '../common/modules/ProductModal';
import ProductImageSliderModal from '../common/modules/productImageslider';
import { Pagination } from '../common/Pagination';
import Select from "react-select";
import {
  loading,
  Updateloading,
} from '../common/helpers/toastify';
import { useTranslation } from 'react-i18next';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx'
import { useSelector } from 'react-redux';
import './inventory.scss';

const SORT_KEYS = [
  null, null, "sku", "item", "collection", "metal", "stone", "size",
  "location", "stock", "reserved", "available",
];
const SORT_ACCESSORS = {
  sku: (r) => r?.SKU,
  item: (r) => r?.item_code || r?.item_name,
  collection: (r) => r?.collection_code || r?.collection_name,
  metal: (r) => r?.metal_code || r?.metal_name,
  stone: (r) => r?.stone_code || r?.stone_name,
  size: (r) => r?.sizename,
  location: (r) => r?.location_name,
  stock: (r) => Number(r?.totalStock) || 0,
  reserved: (r) => Number(r?.reserveStock) || 0,
  available: (r) => Number(r?.availableStock) || 0,
};

const InventorySummary = (props) => {
  const { t } = useTranslation()
  const dataFetched = useRef();
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const [summarylist, setSummarylist] = useState()
  const [limit, setLimit] = useState(100)
  const [totalcount, setTotalcount] = useState()
  const [imageid, setImageid] = useState()
  const [getoneproduct, setOneproduct] = useState()
  const [newcolumndata, setnewcolumndata] = useState(inventorySummarytableHead)
  const [sortConfig, setSortConfig] = useState({ key: "sku", direction: "asc" })
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [socialurl, setSocialurl] = useState()
  const [shareloader, setShareloader] = useState(false)
  const [datalodaer, setDatsLodaer] = useState(false)
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]
  const [state, setstate] = useState({
    totalPages: 0,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate((prev) => ({ ...prev, currentPage: current }));
  };
  const GetSummary = useCallback(async (firstlimit, search) => {
    setDatsLodaer(true)
    try {
      const postdata = {
        search: search ? search : "",
        limit: firstlimit ? firstlimit : limit,
        skip: 0,
      }
      let res = await _Api(postdata, `api/v1/Inventory/my/getSummery`)
      if (res?.code === 200) {
        setSummarylist(res?.data || [])
        setTotalcount(res?.count)
        setstate((prev) => ({ ...prev, currentPage: 1 }));
      } else {
        setSummarylist([])
        setstate({ totalPages: 0, currentPage: 1 });
      }
    } catch (err) {
      console.log(err, 'err')
    } finally {
      setDatsLodaer(false)
    }
  }, [limit]);

  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" }
    );
  };

  const sortedList = useMemo(() => {
    const list = summarylist || [];
    const accessor = SORT_ACCESSORS[sortConfig.key];
    if (!accessor) return list;
    const sorted = [...list].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null) return 1;
      if (bv === undefined || bv === null) return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [summarylist, sortConfig]);

  const pageSize = Number(limit) || 100;
  const pagedList = useMemo(() => {
    const start = ((Number(currentPage) || 1) - 1) * pageSize;
    return sortedList.slice(start, start + pageSize);
  }, [sortedList, currentPage, pageSize]);

  useEffect(() => {
    const pages = Math.ceil(sortedList.length / pageSize) || 0;
    setstate((prev) => {
      const nextPage = pages ? Math.min(prev.currentPage, pages) : 1;
      if (prev.totalPages === pages && prev.currentPage === nextPage) return prev;
      return { totalPages: pages, currentPage: nextPage };
    });
  }, [sortedList, pageSize]);

  useEffect(() => {
    callcolumns()
  }, [])

  const callcolumns = async () => {
    try {
      const postdata = {
        name: 'tbl_my_inventorySummary',
      }
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      )
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    GetSummary()
  }, [GetSummary])

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".inventory-summary-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--inventory-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncInventoryTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    let frame = 0;
    const syncInventoryTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, 40)));
        }
        const total = widths.reduce((sum, w) => sum + w, 0);
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }
      });
    };

    syncInventoryTableWidths();
    window.addEventListener("resize", syncInventoryTableWidths);
    const observer = new ResizeObserver(syncInventoryTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncInventoryTableWidths);
      observer.disconnect();
    };
  }, [pagedList, newcolumndata, datalodaer]);

  const getsharesummary = async () => {
    setShareloader(true)
    try {
      const postdata = {
        search: "",
      }
      let res = await _Api(postdata, `api/v1/Inventory/inventory/print/summery`)

      if (res.code === 200) {
        setSocialurl(res?.link)
        setShareloader(false)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const getprintsummary = async () => {
    let GetloadingID = loading()
    try {
      const postdata = {
        search: "",
      }
      let res = await _Api(postdata, `api/v1/Inventory/inventory/print/summery`)

      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement('a')
          exportLinkElement.hidden = true
          exportLinkElement.download = res?.name ? res?.name : 'report.pdf'
          exportLinkElement.href = res?.link
          exportLinkElement.text = 'downloading...'
          exportLinkElement.setAttribute('target', '_blank')
          document.body.appendChild(exportLinkElement)
          exportLinkElement.click()
          exportLinkElement.remove()
          Updateloading(t, GetloadingID, t('download successfully'))
        }, 50)
        setSocialurl(res?.link)
      } else {
        Updateloading(t, GetloadingID, res?.message ? (res?.message) : (res?.errors), 'error');
      }
    } catch (err) {
      console.log(err, 'err')
      Updateloading(t, GetloadingID, err, t('error'))
    }
  }
  const downloadexclsheet = async () => {
    let header_values = [];
    let bodyarray = [];
    inventorySummarytableHead.map(async (r, k) => {
      header_values.push(r?.lable)
    })

    if (summarylist.length) {
      summarylist.forEach((result, key) => {

        bodyarray.push([key + 1, result?.main_image, result?.SKU, result?.item_code, result?.item_name, result?.collection_name, result?.metal_name, result?.stone_name, result?.location_name, result?.totalStock, result?.reserveStock, result?.availableStock
        ])
      })
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(bodyarray, { origin: 'A2', skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: 'A1' });
    XLSX.utils.book_append_sheet(wb, ws, 'Records');
    const fileContent = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([fileContent], { type: fileType });
    FileSaver.saveAs(data, "my_inventorySummary");

  }
  return (
    <React.Fragment>
      <div className="main-body inventory-summary-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-inventory-page" ref={stickyTopRef}>
              <h1 className="main-body-heading">{t('Summary')}</h1>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + 'images/icons/free-stock.png'}
                        className="inventory-img"
                        alt="Stock"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t('Stock')}</p>
                      <h2 className="inventory-value stock">
                        {totalcount?.totalStock ? totalcount?.totalStock : 0}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + 'images/icons/reserved-icon.png'}
                        className="inventory-img"
                        alt="sku"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t('Reserved')}</p>
                      <h2 className="inventory-value sku">
                        {totalcount?.reserveStock
                          ? totalcount?.reserveStock
                          : 0}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + 'images/icons/available-icon.png'}
                        className="inventory-img"
                        alt="value"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t('Available')}</p>
                      <h2 className="inventory-value value">
                        {totalcount?.availableStock
                          ? totalcount?.availableStock
                          : 0}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + 'images/icons/location.png'}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t('Locations')}</p>
                      <h2 className="inventory-value location">
                        {totalcount?.location ? totalcount?.location : 0}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main-body-top-status-bar">
                <Select
                  className="limit-select short mx-3"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    setstate((prev) => ({ ...prev, currentPage: 1 }));
                  }}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
                <div className="main-body-top-status-bar-multi-date-picker">
                  <button className="print-export-dropdown-selected-icon d-none">
                    <img
                      src={base_assets + 'images/icons/printer-icon.png'}
                      alt=""
                    />
                  </button>
                  <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={base_assets + 'images/icons/ellipsis-circular.png'}
                        alt=""
                      />
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className={parmissiondatashow?.Summary?.Print ? "dropdown-item print-dropdown-item" : "d-none"}
                        onClick={(e) => {
                          getprintsummary(e.target.value)
                        }}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/printer-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('print')}</span>
                      </li>
                      <li className="dropdown-item" onClick={(e) => {
                        downloadexclsheet(e.target.value)
                      }}>
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/export-x-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('export')}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#socialModal"
                        onClick={() => getsharesummary()}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/share-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('share')}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#columnModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/column-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('column')}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative"
                style={{
                  maxWidth: "100%",
                  overflow: "visible",
                  width: "100%",
                }}
              >
                <div className="my-inventory-sticky-thead">
                  <div
                    className="my-inventory-table-hscroll my-inventory-table-hscroll--head"
                    ref={tableHeadScrollRef}
                    onScroll={() => syncInventoryTableScroll("head")}
                  >
                    <table
                      ref={tableHeadTableRef}
                      className="stripe row-border order-column common-table table-striped main-table my-inventory-head-table"
                    >
                      <thead>
                        <tr>
                          {newcolumndata?.map((col, index) => {
                            if (!col?.status) return null;
                            const sortKey = SORT_KEYS[index];
                            const active = sortConfig.key === sortKey;
                            return (
                              <th
                                key={index}
                                className={col.class}
                                onClick={sortKey ? () => handleSort(sortKey) : undefined}
                                style={sortKey ? { cursor: "pointer" } : undefined}
                              >
                                {t(col.lable)}
                                {sortKey ? (
                                  <div className="up-down-arrow-btn">
                                    <img
                                      className={
                                        "up-down-arrow-img up-down-arrow-img-forward" +
                                        (active && sortConfig.direction === "desc" ? "" : " active")
                                      }
                                      src={base_assets + "images/icons/up-down-arrow.png"}
                                      alt=""
                                    />
                                    <img
                                      className={
                                        "up-down-arrow-img up-down-arrow-img-reverse" +
                                        (active && sortConfig.direction === "desc" ? " active" : "")
                                      }
                                      src={base_assets + "images/icons/up-down-arrow-reverse.png"}
                                      alt=""
                                    />
                                  </div>
                                ) : null}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
                <div
                  className="my-inventory-table-hscroll my-inventory-table-hscroll--body"
                  ref={tableBodyScrollRef}
                  onScroll={() => syncInventoryTableScroll("body")}
                >
                <table
                  id="tbl_my_inventorySummary"
                  ref={tableBodyTableRef}
                  className="stripe row-border order-column common-table table-striped main-table w-100"
                >
                  <tbody>
                    <>
                      {pagedList.length
                        ? pagedList.map((result, key) => {
                          return (
                            <tr
                              key={`${result?.product_id || ""}-${result?.location_name || ""}-${result?.SKU || ""}-${key}`}
                              className=""
                            >
                              {newcolumndata?.[0]?.status !== false ? <td className="fixed-side">{(currentPage - 1) * (Number(limit) || 0) + key + 1}</td> : null}
                              {newcolumndata?.[1]?.status !== false ? (
                              <td
                                className="table-pro-img"
                                onClick={() => setImageid(result?.product_id)}
                                data-bs-toggle="modal"
                                data-bs-target="#ProductViewModal"
                              >
                                <img
                                  src={
                                    result?.main_image
                                      ? result?.main_image
                                      : base_assets +
                                      'images/icon/camera_profile.png'
                                  }
                                  alt=""
                                />
                              </td>
                              ) : null}
                              {newcolumndata?.[2]?.status !== false ? (
                              <td className="sku-col link-color">
                                <span
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setOneproduct(result)
                                  }}
                                  data-bs-toggle="modal"
                                  data-bs-target="#ProductInfoModal"
                                >

                                  {result?.SKU ? result?.SKU : ''}
                                </span>
                              </td>
                              ) : null}
                              {newcolumndata?.[3]?.status !== false ? (
                              <td>
                                <div className="tooltip-area-up">
                                  {result?.item_code ? result?.item_code : ''}
                                  <span className="tooltip-area-up-text">
                                    {result?.item_name ? result?.item_name : ''}
                                  </span>
                                </div>
                              </td>
                              ) : null}
                              {newcolumndata?.[4]?.status !== false ? (
                              <td>
                                <div className="tooltip-area-up">
                                  {result?.collection_code
                                    ? result?.collection_code
                                    : ''}
                                  <span className="tooltip-area-up-text">
                                    {result?.collection_name
                                      ? result?.collection_name
                                      : ''}
                                  </span>
                                </div>
                              </td>
                              ) : null}
                              {newcolumndata?.[5]?.status !== false ? (
                              <td>
                                <div className="tooltip-area-up">
                                  {result?.metal_code ? result?.metal_code : ''}
                                  <span className="tooltip-area-up-text">
                                    {result?.metal_name
                                      ? result?.metal_name
                                      : ''}
                                  </span>
                                </div>
                              </td>
                              ) : null}
                              {newcolumndata?.[6]?.status !== false ? (
                              <td>
                                <div className="tooltip-area-up">
                                  {result?.stone_code ? result?.stone_code : ''}
                                  <span className="tooltip-area-up-text">
                                    {result?.stone_name
                                      ? result?.stone_name
                                      : ''}
                                  </span>
                                </div>
                              </td>
                              ) : null}
                              {newcolumndata?.[7]?.status !== false ? (
                              <td>
                                {result?.sizename ? result?.sizename : ''}
                              </td>
                              ) : null}
                              {newcolumndata?.[8]?.status !== false ? (
                              <td className="link-color">
                                {result?.location_name
                                  ? result?.location_name
                                  : ''}
                              </td>
                              ) : null}
                              {newcolumndata?.[9]?.status !== false ? (
                              <td className="light-blue-text">
                                {result?.totalStock ? result?.totalStock : '0'}
                              </td>
                              ) : null}
                              {newcolumndata?.[10]?.status !== false ? (
                              <td className="yellow-text">

                                {result?.reserveStock
                                  ? result?.reserveStock
                                  : '0'}
                              </td>
                              ) : null}
                              {newcolumndata?.[11]?.status !== false ? (
                              <td className="main-green-text">
                                {result?.availableStock
                                  ? result?.availableStock
                                  : '0'}
                              </td>
                              ) : null}
                            </tr>
                          )
                        })
                        : ''}
                    </>
                  </tbody>
                </table>
                </div>
                <div id="table_loader" className={datalodaer ? "mt-4" : "d-none"}>
                  <div className="dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
              {summarylist?.length > 0 ? (
                <Pagination
                  total={totalPages}
                  current={currentPage}
                  pagination={(crPage) => handlePaginations(crPage)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />
        <ProductModal
          data_product={getoneproduct}
          setOneproduct={setOneproduct}
          editproduct_submit={''}
        />
        <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
      </div>
      <TableColumnModal
        tablehead={inventorySummarytableHead}
        tblName={'tbl_my_inventorySummary'}
        calldatatable={GetSummary}
        setnewcolumndata={setnewcolumndata}
      ></TableColumnModal>
      <ConfirmationModel></ConfirmationModel>
    </React.Fragment>
  )
}
export default InventorySummary;
